import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { tLoadingElement } from 'src/app/services/app-config.typings';
import { CustomUIConfigService } from 'src/app/services/custom-ui-config.service';

@Component({
  selector: 'app-response-modal',
  templateUrl: './response-modal.component.html',
  styleUrls: ['./response-modal.component.scss'],
  host: { class: 'd-block' },
})

export class ResponseModalComponent implements OnInit {

  @Input() resources: any;

  loadObj: tLoadingElement;
  showSuccess: boolean = false;
  stillProcessing: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private uiConfigService: CustomUIConfigService,
  ) {}

  ngOnInit() {
    this.loadObj = this.uiConfigService.initialiseLoadingBooleans(true);
    if (this.resources && this.resources.length > 0) {
      const hardFailures = this.resources.filter((x: any) => x.valid == false && !x.stillProcessing);
      this.stillProcessing = this.resources.filter((x: any) => x.stillProcessing).length > 0;
      this.loadObj.loadError = hardFailures.length > 0;
      this.showSuccess = hardFailures.length === 0 && !this.stillProcessing;
    }
  }

  close() {
    this.activeModal.dismiss()
  }

}